import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faMagnifyingGlass,
    faChevronRight,
    faChevronDown,
    faTrash,
    faPen,
    faPlus,
    faGear,
    faXmark,
    faCheck,
    faTag,
} from "@fortawesome/free-solid-svg-icons";
import {
    faPenToSquare,
    faCircleXmark,
    faFloppyDisk,
    faTrashCan,
} from "@fortawesome/free-regular-svg-icons";
import { useEffect, useRef, useState } from "react";
import Loading from "./Loading";
import PrimaryButton from "../components/PrimaryButton";
import SecondaryButton from "../components/SecondaryButton";
import { formatValue } from '../utils/formatValue';
import Modal from "../components/Modal.js";
import Input from "../components/Input.js";
import axiosInstance from '../axiosConfig';
import ConfirmDeleteModal from '../components/ConfirmDeleteModal';
import { handleError } from "../services/handleError.js";
import { showToast } from "../components/Toast.js";
import ModalNovoInsumo from "../components/ModalNovoInsumo";
import AddAdicionaisProduto from "../components/AddAdicionaisProduto.js";
import { X } from "lucide-react";
import PerguntasProduto from "../components/PerguntasProduto.js";

function GestaoCardapio() {
    const [secoesAbertas, setSecoesAbertas] = useState({});
    const [produtos, setProdutos] = useState({});
    const [adicionais, setAdicionais] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [categoriaEdit, setCategoriaEdit] = useState({ id: null, nome: "" });
    const [categoriaDelete, setCategoriaDelete] = useState();
    const [produtoDelete, setProdutoDelete] = useState();
    const [isModalAddProduct, setIsModalAddProduct] = useState(false);
    const [isModalAddCategory, setIsModalAddCategory] = useState(false);
    const [isModalAdicionais, setIsModalAdicionais] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const searchAdicionais = useRef(null);
    const inputSearch = useRef(null);
    const inputCategoria = useRef(null);
    const inputEditCategoria = useRef(null);
    const [cateCreate, setCateCreate] = useState(0);
    const [permiteDivisao, setPermiteDivisao] = useState(false);
    const [editandoProduto, setEditandoProduto] = useState(false);
    const [idProdutoEdit, setIdProdutoEdit] = useState('');
    const [titulo, setTitulo] = useState('');
    const [produtoAtivo, setProdutoAtivo] = useState('');
    const [descricao, setDescricao] = useState('');
    const [valor, setValor] = useState('');
    const [tipo, setTipo] = useState('');
    const [imagem, setImagem] = useState(null);
    const [urlImagem, setUrlImagem] = useState('');
    const [maxAdicionais, setMaxAdicionais] = useState(0);
    const [alterandoAdicional, setAlterandoAdicional] = useState(-1);
    const [tituloAdicional, setTituloAdicional] = useState(null);
    const [valorExtraAdicional, setValorExtraAdicional] = useState(null);
    const [adicionaisProduto, setAdicionaisProduto] = useState([]);
    const [perguntasProduto, setPerguntasProduto] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isPorKg, setIsPorKg] = useState(false);
    const [novoInsumo, setNovoInsumo] = useState(null);
    const [insumosSelecionados, setInsumosSelecionados] = useState([]);
    const [controlaEstoque, setControlaEstoque] = useState(false);
    const [produtoPronto, setProdutoPronto] = useState(true);
    const [query, setQuery] = useState('');
    const [insumoSelecionado, setInsumoSelecionado] = useState(null);
    const [quantidadeInsumo, setQuantidadeInsumo] = useState(1);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [sugestoes, setSugestoes] = useState([]);
    const [insumos, setInsumos] = useState([]);
    const [quantidadeMinimaAlerta, setQuantidadeMinimaAlerta] = useState([]);
    const [isPromoOpen, setIsPromoOpen] = useState(false);
    const [produtoSelecionado, setProdutoSelecionado] = useState(null);
    const [promoAtiva, setPromoAtiva] = useState(false);
    const [valorPromocional, setValorPromocional] = useState('');

    const adicionarInsumo = (insumo) => {
        if (insumosSelecionados.find(i => i.insumo_id === insumo.id)) return;
        setInsumosSelecionados([...insumosSelecionados, { ...insumo, quantidade: insumo.quantidade }]);
    }

    const removerInsumo = (id) => {
        setInsumosSelecionados(insumosSelecionados.filter(i => i.id !== id));
    }

    const openModalPromocao = (produto, categoriaId) => {
        setProdutoSelecionado({ ...produto, categoriaId });
        setPromoAtiva(produto.emPromocao || false);
        setValorPromocional(produto.valorPromocional || '');
        setIsPromoOpen(true);
    };

    const closeModalPromocao = () => {
        setIsPromoOpen(false);
        setProdutoSelecionado(null);
    };

    const handleSubmitPromocao = async () => {
        if (valorPromocional >= produtoSelecionado?.valor) {
            showToast("O valor promocional deve ser menor que o valor original.", "error", 4000);
            return;
        }

        setLoading(true);

        try {
            const response = await axiosInstance.put(`/Produto/AlterarPromocao/${produtoSelecionado?.id}`, {
                emPromocao: promoAtiva,
                valorPromocional
            });

            if (response.status === 204) {
                setProdutos(prevProdutos => {
                    const updatedProducts = [...prevProdutos[produtoSelecionado.categoriaId]];
                    const index = updatedProducts.findIndex(p => p.id === produtoSelecionado.id);
                    if (index !== -1) {
                        updatedProducts[index] = {
                            ...updatedProducts[index],
                            emPromocao: promoAtiva,
                            valorPromocional
                        };
                    }
                    return {
                        ...prevProdutos,
                        [produtoSelecionado.categoriaId]: updatedProducts
                    };
                });

                closeModalPromocao();

                showToast("Sucesso!", "success", 3000, "Promoção atualizada com sucesso!");
            }
        } catch (error) {
            handleError(error, "Falha ao atualizar promoção.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const adicionadosIds = insumosSelecionados.map(i => i.insumo_id || i.id);

        const disponiveis = insumos.filter((insumo) =>
            !adicionadosIds.includes(insumo.id)
        );

        if (showSuggestions && query === '') {
            setSugestoes(disponiveis.slice(0, 5));
        } else if (query !== '') {
            const filtrados = disponiveis.filter((insumo) =>
                insumo.nome.toLowerCase().includes(query.toLowerCase())
            );
            setSugestoes(filtrados);
        }
    }, [query, showSuggestions, insumos, insumosSelecionados]);

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImagem(file);
            setUrlImagem(URL.createObjectURL(file));
        }
    };

    const openModal = () => setIsModalAddProduct(true);

    const openModalEditProduto = (produto, categoria) => {
        setIsModalAddProduct(true);
        setCateCreate(categoria);
        setEditandoProduto(true);
        setIdProdutoEdit(produto.id);
        setTitulo(produto.titulo);
        setProdutoAtivo(produto.ativo);
        setDescricao(produto.descricao);
        setValor(produto.valor);
        setTipo(produto.tipo);
        setUrlImagem(produto.url_Imagem);
        setMaxAdicionais(produto.max_Adicionais);
        setIsPorKg(produto.porKg);
        setControlaEstoque(produto.controlaEstoque);
        setProdutoPronto(produto.produtoPronto);
        setQuantidadeMinimaAlerta(produto.quantidadeMinimaAlerta);
        buscarAdicionaisProduto(produto.id);
        buscarInsumosProduto(produto.id);
        buscarPerguntasProduto(produto.id);
    }

    const limparCamposEdicao = () => {
        setTitulo("");
        setDescricao("");
        setValor("");
        setTipo("");
        setImagem(null);
        setUrlImagem("");
        setMaxAdicionais(0);
        setAdicionaisProduto([]);
        setInsumosSelecionados([])
        setControlaEstoque(false);
        setProdutoPronto(true);
        setQuantidadeMinimaAlerta([])
        setInsumoSelecionado(null);
    }

    const openAddCategoria = () => setIsModalAddCategory(true);

    const openAdicionais = () => setIsModalAdicionais(true);

    const closeModal = () => {
        setIsModalAddProduct(false);
        setIsModalAddCategory(false);
        setIsModalAdicionais(false);
        setIsPorKg(false);
        setCategoriaDelete();
        setProdutoDelete();
    };

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        buscarTodosInsumos();
        buscarCategorias();

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    async function buscarCategorias(filtro) {
        setLoading(true);

        try {
            const url = filtro ? `Categoria/GetCategorias?nome=${filtro}` : 'Categoria/GetCategorias';
            const response = await axiosInstance.get(url);

            setCategorias(response.data)
        } catch (error) {
            handleError(error, "Falha ao carregar os dados.");
        } finally {
            setLoading(false);
        }
    };

    async function buscarAdicionais(filtro) {
        setLoading(true);

        try {
            const url = filtro ? `Adicionais?nome=${filtro}` : 'Adicionais';
            const response = await axiosInstance.get(url);

            setAdicionais(response.data)
        } catch (error) {
            handleError(error, "Falha ao carregar os dados.");
        } finally {
            setLoading(false);
        }
    };

    async function buscarAdicionaisProduto(produtoId) {
        setLoading(true);

        try {
            var rota = produtoId === undefined ? "Adicionais" : `Adicionais/produto/${produtoId}/todos`
            const response = await axiosInstance.get(rota);

            setAdicionaisProduto(response.data)
        } catch (error) {
            handleError(error, "Falha ao carregar os dados.");
        } finally {
            setLoading(false);
        }
    };

    async function buscarInsumosProduto(produtoId) {
        setLoading(true);

        try {
            const response = await axiosInstance.get(`ProdutoInsumo/${produtoId}`);

            setInsumosSelecionados(response.data)
        } catch (error) {
            handleError(error, "Falha ao carregar os dados.");
        } finally {
            setLoading(false);
        }
    };

    async function buscarPerguntasProduto(produtoId) {
        setLoading(true);

        try {
            const response = await axiosInstance.get(`Produto/${produtoId}/perguntas`);
            setPerguntasProduto(response.data);
        } catch (error) {
            handleError(error, "Falha ao carregar as perguntas do produto.");
        } finally {
            setLoading(false);
        }
    }

    async function buscarTodosInsumos() {
        setLoading(true);

        try {
            const response = await axiosInstance.get('Insumos');

            setInsumos(response.data)
        } catch (error) {
            handleError(error, "Falha ao carregar os dados.");
        } finally {
            setLoading(false);
        }
    };

    const toggleSecao = async (id) => {
        setSecoesAbertas(prevState => ({
            ...prevState,
            [id]: !prevState[id]
        }));

        // Se a seção está sendo aberta e os produtos ainda não foram buscados
        if (!produtos[id] && !secoesAbertas[id]) {
            setLoading(true);
            try {
                const response = await axiosInstance.get(`/Produto/GetProdutosByCategoria?categoriaId=${id}`);
                setProdutos(prevProdutos => ({
                    ...prevProdutos,
                    [id]: response.data,
                }));
            } catch (error) {
                handleError(error, "Falha ao carregar os dados.");
            } finally {
                setLoading(false);
            }
        }
    };

    const toggleSelecionado = (id) => {
        setAdicionaisProduto(prevState =>
            prevState.map(adicional =>
                adicional.id === id
                    ? { ...adicional, selecionado: !adicional.selecionado }
                    : adicional
            )
        );
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        buscarCategorias(inputSearch.current.value);
    };

    const formCategoriaSubmit = (event) => {
        event.preventDefault();
        criarCategoria(inputCategoria.current.value);
    };

    async function cadastrarAdicional() {
        if (tituloAdicional === "" || tituloAdicional == null)
            return handleError("Informe o título do adicional");

        var dados = {
            nome: tituloAdicional,
            valorExtra: valorExtraAdicional == null || valorExtraAdicional === "" ? 0 : valorExtraAdicional,
            ativo: true
        }

        setLoading(true);

        try {
            const response = await axiosInstance.post("Adicionais", dados);

            showToast("Sucesso!", "success", 3000, "Adicionais criados com sucesso");

            dados.id = response.data;

            setAdicionais(prevAdicionais => [...prevAdicionais.filter(adicional => adicional.id !== 0), dados]);

            setAlterandoAdicional(-1);
            setTituloAdicional(null);
            setValorExtraAdicional(null);
        } catch (error) {
            handleError(error, "Falha ao cadastrar o adicional.");
        } finally {
            setLoading(false);
        }
    };

    async function atualizarAdicional(id) {
        if (tituloAdicional === "" || tituloAdicional == null)
            return handleError("Informe o título do adicional");

        var dados = {
            id: alterandoAdicional,
            nome: tituloAdicional,
            valorExtra: valorExtraAdicional == null || valorExtraAdicional === "" ? 0 : valorExtraAdicional,
            ativo: true
        }

        setLoading(true);

        try {
            await axiosInstance.put("Adicionais/" + id, dados);

            showToast("Sucesso!", "success", 3000, "Adicionais atualizados com sucesso");

            setAdicionais(prevAdicionais =>
                prevAdicionais.map(adicional =>
                    adicional.id === id ? dados : adicional
                )
            );
            setAlterandoAdicional(-1);
            setTituloAdicional(null);
            setValorExtraAdicional(null);
        } catch (error) {
            handleError(error, "Falha ao atualizar o adicional.");
        } finally {
            setLoading(false);
        }
    };

    async function editCategoriaSubmit(id, categoria) {
        let novoNome = inputEditCategoria.current.value;

        setLoading(true);

        try {
            await axiosInstance.put("Categoria/" + id, { Nome: novoNome, PermiteDivisao: categoriaEdit.permiteDivisao });

            showToast("Sucesso!", "success", 3000, "Categoria atualizada com sucesso");

            setCategorias(prevCategorias =>
                prevCategorias.map(categoria =>
                    categoria.id === categoriaEdit.id ? categoriaEdit : categoria
                )
            );
            setCategoriaEdit({ id: null, nome: "" });
        } catch (error) {
            handleError(error, "Falha ao atualizar a categoria.");
        } finally {
            setLoading(false);
        }
    };

    async function deleteAdicional(id) {
        setLoading(true);

        try {
            await axiosInstance.delete("Adicionais/" + id);

            setAdicionais(prevAdicionais => prevAdicionais.filter(adicional => adicional.id !== id));
        } catch (error) {
            handleError(error, "Falha ao deletar o adicional.");
        } finally {
            setLoading(false);
        }
    };

    async function inativarCategoriaSubmit(id, status) {
        setLoading(true);

        try {
            await axiosInstance.put("Categoria/AlterarStatusCategoria/" + id, { Ativo: status });

            closeModal();
            setCategorias(prevCategorias =>
                prevCategorias.map(categoria =>
                    categoria.id === id ? { ...categoria, ativo: status } : categoria
                )
            );
            setCategoriaEdit({ id: null, nome: "" });

            showToast("Sucesso!", "success", 3000, "Categoria inativada com sucesso");
        } catch (error) {
            handleError(error, "Falha ao inativar a categoria.");
        } finally {
            setLoading(false);
        }
    };

    async function criarCategoria(nome) {
        setLoading(true);

        try {
            const response = await axiosInstance.post("Categoria/NovaCategoria", { Nome: nome, PermiteDivisao: permiteDivisao });

            showToast("Sucesso!", "success", 3000, "Categoria criada com sucesso");

            closeModal();

            const novaCategoria = {
                id: response.data,
                nome: nome,
                ativo: true,
                permiteDivisao: permiteDivisao
            };

            setCategorias([...categorias, novaCategoria]);
        } catch (error) {
            handleError(error, "Falha ao cadastrar a categoria.");
        } finally {
            setLoading(false);
        }
    };

    const handleCreateProduct = async () => {
        if (!imagem) {
            handleError("Selecione uma imagem para o produto.");
            return;
        }

        if (!titulo || !descricao || !valor || !tipo) {
            handleError("Preencha todos os campos corretamente.");
            return;
        }

        for (const pergunta of perguntasProduto) {
            if (!pergunta.texto.trim()) {
                handleError("Uma das perguntas está sem texto.");
                return;
            }

            if (pergunta.obrigatoria && pergunta.opcoes.length === 0) {
                handleError(`A pergunta "${pergunta.texto}" é obrigatória e precisa de pelo menos uma opção.`);
                return;
            }

            for (const opcao of pergunta.opcoes) {
                if (!opcao.texto.trim()) {
                    handleError(`Uma das opções da pergunta "${pergunta.texto}" está sem texto.`);
                    return;
                }
                if (opcao.valorExtra < 0) {
                    handleError(`A opção "${opcao.texto}" da pergunta "${pergunta.texto}" não pode ter valor negativo.`);
                    return;
                }
            }
        }

        const formData = new FormData();
        formData.append("titulo", titulo);
        formData.append("descricao", descricao);
        formData.append("valor", valor);
        formData.append("tipo", tipo);
        formData.append("porKg", isPorKg ?? false);
        formData.append("categoria", cateCreate);
        formData.append("imagem", imagem);
        formData.append("max_adicionais", maxAdicionais);
        formData.append("controla_estoque", controlaEstoque);
        formData.append("produto_pronto", produtoPronto);
        formData.append("qtd_alerta", controlaEstoque ? quantidadeMinimaAlerta : 0);

        const idsAdicionaisSelecionados = adicionaisProduto
            .filter(adicional => adicional.selecionado)
            .map(adicional => adicional.id);

        formData.append("adicionais", JSON.stringify(idsAdicionaisSelecionados));
        formData.append("insumos", JSON.stringify(insumosSelecionados));

        perguntasProduto.forEach((p, i) => {
            p.Ordem = i;
            p.opcoes.forEach((o, j) => o.Ordem = j);
        });
        formData.append("perguntas", JSON.stringify(perguntasProduto));

        setLoading(true);

        try {
            const response = await axiosInstance.post("Produto", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response.status === 201) {
                closeModal();

                const novoProduto = {
                    id: response.data,
                    ativo: true,
                    titulo,
                    descricao,
                    valor,
                    tipo,
                    porkg: isPorKg ?? false,
                    categoria: cateCreate,
                    max_Adicionais: maxAdicionais,
                    url_Imagem: URL.createObjectURL(imagem),
                    controlaEstoque,
                    produtoPronto,
                    quantidadeMinimaAlerta: controlaEstoque ? quantidadeMinimaAlerta : 0,
                    perguntas: perguntasProduto
                };

                setProdutos((prevProdutos) => ({
                    ...prevProdutos,
                    [cateCreate]: [...(prevProdutos[cateCreate] || []), novoProduto],
                }));

                limparCamposEdicao();
                setEditandoProduto(false);

                showToast("Sucesso!", "success", 3000, "Produto criado com sucesso");
            }
        } catch (error) {
            handleError(error, "Erro ao cadastrar produto");
        } finally {
            setLoading(false);
        }
    };

    const handleUpdateProduct = async (id) => {
        for (const pergunta of perguntasProduto) {
            if (!pergunta.texto.trim()) {
                handleError("Uma das perguntas está sem texto.");
                return;
            }

            if (pergunta.obrigatoria && pergunta.opcoes.length === 0) {
                handleError(`A pergunta "${pergunta.texto}" é obrigatória e precisa de pelo menos uma opção.`);
                return;
            }

            for (const opcao of pergunta.opcoes) {
                if (!opcao.texto.trim()) {
                    handleError(`Uma das opções da pergunta "${pergunta.texto}" está sem texto.`);
                    return;
                }
                if (opcao.valorExtra < 0) {
                    handleError(`A opção "${opcao.texto}" da pergunta "${pergunta.texto}" não pode ter valor negativo.`);
                    return;
                }
            }
        }

        const formData = new FormData();
        formData.append("titulo", titulo);
        formData.append("descricao", descricao);
        formData.append("valor", valor);
        formData.append("tipo", tipo);
        formData.append("porKg", isPorKg ?? false);
        formData.append("categoria", cateCreate);
        formData.append("max_adicionais", maxAdicionais);
        formData.append("controla_estoque", controlaEstoque);
        formData.append("produto_pronto", produtoPronto);
        formData.append("qtd_alerta", controlaEstoque ? quantidadeMinimaAlerta : 0);

        const idsAdicionaisSelecionados = adicionaisProduto
            .filter(adicional => adicional.selecionado)
            .map(adicional => adicional.id);

        const insumosConvertidos = insumosSelecionados.map(insumo => ({
            InsumoId: insumo.insumo_id || insumo.id,
            Quantidade: insumo.quantidade
        }));

        formData.append("adicionais", JSON.stringify(idsAdicionaisSelecionados));
        formData.append("insumos", JSON.stringify(insumosConvertidos));

        perguntasProduto.forEach((p, i) => {
            p.Ordem = i;
            p.opcoes.forEach((o, j) => o.Ordem = j);
        });
        formData.append("perguntas", JSON.stringify(perguntasProduto));

        if (imagem) {
            formData.append("imagem", imagem);
        } else {
            formData.append("urlImagem", urlImagem);
        }

        setLoading(true);

        try {
            const response = await axiosInstance.put(`Produto/${id}`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response.status === 204) {
                closeModal();

                const produtoEdit = {
                    id,
                    titulo,
                    descricao,
                    valor,
                    tipo,
                    porkg: isPorKg ?? false,
                    ativo: produtoAtivo,
                    max_Adicionais: maxAdicionais,
                    url_Imagem: imagem != null ? URL.createObjectURL(imagem) : urlImagem,
                    categoria: cateCreate,
                    controlaEstoque,
                    produtoPronto,
                    quantidadeMinimaAlerta: controlaEstoque ? quantidadeMinimaAlerta : 0,
                    perguntas: perguntasProduto
                };

                setProdutos((prevProdutos) => ({
                    ...prevProdutos,
                    [cateCreate]: prevProdutos[cateCreate].map((produto) =>
                        produto.id === produtoEdit.id ? produtoEdit : produto
                    ),
                }));

                limparCamposEdicao();
                setAdicionaisProduto([]);

                showToast("Sucesso!", "success", 3000, "Produto atualizado com sucesso");
            }
        } catch (error) {
            handleError(error, "Erro ao atualizar produto");
        } finally {
            setLoading(false);
        }
    };

    const alterarStatusProduto = async (produtoId, categoriaId, status) => {
        setLoading(true);

        try {
            const response = await axiosInstance.put(`/Produto/AlterarStatusProduto/${produtoId}`, { Ativo: status });
            if (response.status === 204) {
                setProdutos(prevProdutos => {
                    const updatedProducts = [...prevProdutos[categoriaId]];
                    const index = updatedProducts.findIndex(produto => produto.id === produtoId);
                    if (index !== -1) {
                        updatedProducts[index] = { ...updatedProducts[index], ativo: status };
                    }
                    return {
                        ...prevProdutos,
                        [categoriaId]: updatedProducts
                    };
                });

                closeModal();

                showToast("Sucesso!", "success", 3000, "Produto inativado com sucesso");
            }
        } catch (error) {
            handleError(error, "Falha ao alterar status produto.");
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async (insumo) => {
        try {
            await axiosInstance.post("Insumos", insumo);

            setInsumos((prev) => {
                const existe = prev.find((i) => i.id === insumo.id);
                if (existe) {
                    return prev.map((i) => (i.id === insumo.id ? insumo : i));
                }
                return [...prev, insumo];
            });

            setNovoInsumo(null);
        } catch (error) {
            handleError(error, "Erro ao salvar insumo.");
        }
    };

    const handleNewProduct = (cateId) => {
        openModal();
        setCateCreate(cateId);
        setEditandoProduto(false);
        limparCamposEdicao();
        buscarAdicionaisProduto();
        buscarTodosInsumos();
    };

    if (loading) {
        return <Loading />;
    }

    return (
        <>
            {novoInsumo !== null && (
                <ModalNovoInsumo
                    isOpen={!!novoInsumo}
                    onClose={() => setNovoInsumo(null)}
                    onSave={handleSave}
                    initialData={1}
                />
            )}

            <ConfirmDeleteModal
                isOpen={categoriaDelete || produtoDelete}
                onClose={closeModal}
                onConfirm={() => (categoriaDelete && inativarCategoriaSubmit(categoriaDelete.id, false)) || (produtoDelete && alterarStatusProduto(produtoDelete[0].id, produtoDelete[1].id, false))}
                itemName={(categoriaDelete && "a categoria " + categoriaDelete.nome) || (produtoDelete && "o produto " + produtoDelete[0].titulo + " da categoria " + produtoDelete[0].categoria)}
            />

            <Modal isOpen={isModalAddProduct} onClose={closeModal}>
                <div className="text-black mb-2 flex justify-between items-center">
                    <span className="text-xl font-semibold">
                        {!editandoProduto ? "Novo Produto" : "Editar Produto"}
                    </span>
                    <button onClick={closeModal}>
                        <FontAwesomeIcon icon={faCircleXmark} className="text-3xl" />
                    </button>
                </div>

                <div className="rounded-full bg-gray-300 my-2" style={{ height: "2px" }} />

                <div className="flex space-x-2 justify-between">
                    {/* Imagem */}
                    <div className="space-y-2">
                        <div className="relative w-36 h-full">
                            <input type="file" className="hidden" id="image-upload" onChange={handleImageChange} />
                            <label
                                htmlFor="image-upload"
                                className="w-full h-full flex items-center justify-center bg-gray-200 rounded-lg cursor-pointer relative overflow-hidden"
                            >
                                {urlImagem ? (
                                    <>
                                        <img src={urlImagem} alt="Prévia" className="w-full h-full object-contain rounded-lg" />
                                        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 hover:opacity-100 transition">
                                            <FontAwesomeIcon icon={faPen} className="text-white text-xl" />
                                        </div>
                                    </>
                                ) : (
                                    <FontAwesomeIcon icon={faPlus} className="text-gray-500 text-2xl" />
                                )}
                            </label>
                        </div>
                    </div>

                    {/* Formulário */}
                    <div className="space-y-2 w-full">
                        {/* Cobrar por KG */}
                        <div className="flex items-center justify-between">
                            <span className="text-md text-gray-700 font-medium">Cobrar por peso (kg)?</span>
                            <button
                                onClick={() => setIsPorKg(!isPorKg)}
                                className={`w-14 h-7 flex items-center rounded-full p-1 transition duration-300 ${isPorKg ? "bg-blue-600" : "bg-gray-300"}`}
                            >
                                <div
                                    className={`bg-white w-5 h-5 rounded-full shadow-md transform duration-300 ${isPorKg ? "translate-x-7" : "translate-x-0"}`}
                                />
                            </button>
                        </div>

                        {/* Título e valor */}
                        <div className="space-y-2 md:flex md:space-x-2 md:space-y-0">
                            <Input placeholder="Informe o título" value={titulo} onChange={(e) => setTitulo(e)} />
                            <Input
                                type="number"
                                placeholder={isPorKg ? "Valor por KG" : "Valor unitário"}
                                value={valor}
                                onChange={(e) => setValor(e)}
                            />
                        </div>

                        <Input placeholder="Descrição" value={descricao} onChange={(e) => setDescricao(e)} />
                        <div className="space-y-2 md:flex md:space-x-2 md:space-y-0">
                            <Input placeholder="Tipo" value={tipo} onChange={(e) => setTipo(e)} />
                            <Input
                                type="number"
                                placeholder="Nº Máx. Adicionais"
                                value={maxAdicionais}
                                onChange={(e) => setMaxAdicionais(e)}
                            />
                        </div>
                    </div>
                </div>

                <div className="rounded-full bg-gray-300 my-2" style={{ height: "2px" }} />

                <span className="text-lg font-bold w-full mb-2">Estoque:</span>
                <div className="flex items-center justify-between">

                    <span className="text-md text-gray-700 font-medium">Controlar estoque do produto?</span>
                    <button
                        onClick={() => setControlaEstoque(!controlaEstoque)}
                        className={`w-14 h-7 flex items-center rounded-full p-1 transition duration-300 ${controlaEstoque ? "bg-blue-600" : "bg-gray-300"}`}
                    >
                        <div
                            className={`bg-white w-5 h-5 rounded-full shadow-md transform duration-300 ${controlaEstoque ? "translate-x-7" : "translate-x-0"}`}
                        />
                    </button>
                </div>

                {controlaEstoque && (
                    <div className="flex items-center justify-between mt-1">
                        <span className="text-md text-gray-700 font-medium">Produto pronto (Ex: Coca Cola Lata)?</span>
                        <button
                            onClick={() => setProdutoPronto(!produtoPronto)}
                            className={`w-14 h-7 flex items-center rounded-full p-1 transition duration-300 ${produtoPronto ? "bg-blue-600" : "bg-gray-300"}`}
                        >
                            <div
                                className={`bg-white w-5 h-5 rounded-full shadow-md transform duration-300 ${produtoPronto ? "translate-x-7" : "translate-x-0"}`}
                            />
                        </button>
                    </div>
                )}

                {controlaEstoque && produtoPronto && (
                    <div className="mt-1">
                        <label className="block text-md font-medium text-gray-700">
                            Alertar quando estoque estiver abaixo de:
                        </label>
                        <input
                            type="number"
                            placeholder="Digite a quantidade para o alerta"
                            value={quantidadeMinimaAlerta}
                            onChange={(e) => setQuantidadeMinimaAlerta(Number(e.target.value))}
                            className="w-full border rounded px-3 py-2 focus:outline-none"
                            min={0}
                        />
                    </div>
                )}


                {controlaEstoque && !produtoPronto && (
                    <div onBlur={() => setTimeout(() => setShowSuggestions(false), 150)} className="mt-1 space-y-2">
                        <div>
                            <label className="font-normal block">Buscar insumo:</label>
                            <input
                                type="text"
                                className="w-full border rounded px-3 py-2 focus:outline-none"
                                placeholder="Digite o nome do insumo..."
                                value={query}
                                onChange={(e) => {
                                    setShowSuggestions(true);
                                    setQuery(e.target.value);
                                    setInsumoSelecionado(null);
                                }}
                                onFocus={() => setShowSuggestions(true)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" && sugestoes.length > 0) {
                                        const primeiro = sugestoes[0];
                                        setInsumoSelecionado(primeiro);
                                        setQuery(primeiro.nome);
                                        setShowSuggestions(false);
                                    }
                                }}
                            />
                            {showSuggestions && (query || sugestoes.length > 0) && (
                                <div className="border rounded max-h-60 overflow-auto shadow-sm z-10 bg-white">
                                    {sugestoes.length > 0 ? (
                                        sugestoes.map((insumo) => (
                                            <div
                                                key={insumo.id}
                                                className="px-3 py-2 cursor-pointer hover:bg-gray-100 flex items-center justify-between"
                                                onClick={() => {
                                                    setInsumoSelecionado(insumo);
                                                    setQuery(insumo.nome);
                                                    setShowSuggestions(false);
                                                }}
                                            >
                                                <span>{insumo.nome}</span>
                                                <span className="text-xs text-gray-400">Selecionar</span>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="px-3 py-3 text-sm text-gray-500">
                                            Nenhum insumo encontrado para <strong>"{query}"</strong>
                                        </div>
                                    )}

                                    {/* Link para cadastrar novo insumo */}
                                    <div className="border-t px-3 py-2 bg-gray-50 text-sm hover:bg-gray-100 cursor-pointer text-blue-600 font-medium"
                                        onClick={() => {
                                            setShowSuggestions(false);
                                            setNovoInsumo({});
                                        }}
                                    >
                                        Não achou o que procurava? <span className="underline">Cadastre o insumo agora</span>
                                    </div>
                                </div>
                            )}
                        </div>

                        {insumoSelecionado && (
                            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mt-2">
                                <label className="text-sm font-medium text-gray-600 mb-2 block">
                                    Quantidade utilizada de <span className="font-semibold text-gray-800">"{insumoSelecionado.nome}"</span>:
                                </label>

                                <div className="flex items-center">
                                    <input
                                        type="number"
                                        min={1}
                                        className="border border-gray-300 rounded-lg px-2 py-2 w-20 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 text-center"
                                        value={quantidadeInsumo}
                                        onChange={(e) => setQuantidadeInsumo(Number(e.target.value))}
                                    />
                                    <span className="text-lg ml-1 mr-3">
                                        {insumoSelecionado.unidade ?? 'un'}
                                    </span>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            adicionarInsumo({
                                                ...insumoSelecionado,
                                                quantidade: quantidadeInsumo,
                                            });
                                            setQuery('');
                                            setInsumoSelecionado(null);
                                            setQuantidadeInsumo(1);
                                        }}
                                        className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow hover:bg-blue-700 transition-all duration-200 text-sm"
                                    >
                                        Adicionar
                                    </button>
                                </div>
                            </div>
                        )}

                        {insumosSelecionados.length > 0 && (
                            <div className="mt-4">
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Insumos adicionados:
                                </label>
                                <div className="flex flex-wrap gap-2">
                                    {insumosSelecionados.map((insumo) => (
                                        <div
                                            key={insumo.id}
                                            className="bg-blue-100 text-blue-800 px-3 py-1 rounded-lg flex items-center space-x-2 text-sm"
                                        >
                                            <span className="text-sm font-medium">{insumo.quantidade} {insumo.unidade ?? 'un'} - {insumo.nome}</span>
                                            <button
                                                onClick={() => removerInsumo(insumo.id)}
                                                className="font-bold hover:text-red-600"
                                                type="button"
                                            >
                                                <X className="w-4 h-4 hover:text-red-500" />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                )}

                <div className="rounded-full bg-gray-300 my-2" style={{ height: "2px" }} />

                <span className="text-lg font-bold w-full">Adicionais:</span>

                <AddAdicionaisProduto
                    adicionaisProduto={adicionaisProduto}
                    toggleSelecionado={toggleSelecionado}
                />

                <span className="text-lg font-bold w-full">Perguntas do Produto:</span>

                <PerguntasProduto
                    perguntasProduto={perguntasProduto}
                    setPerguntasProduto={setPerguntasProduto}
                />

                {/* Ações */}
                <div className="flex items-center justify-between space-x-2 mt-3">
                    <SecondaryButton onClick={closeModal}>Cancelar</SecondaryButton>
                    {!editandoProduto ? (
                        <PrimaryButton onClick={handleCreateProduct}>Cadastrar</PrimaryButton>
                    ) : (
                        <PrimaryButton onClick={() => handleUpdateProduct(idProdutoEdit)}>Editar</PrimaryButton>
                    )}
                </div>
            </Modal>


            <Modal isOpen={isModalAddCategory} onClose={closeModal}>
                <div className="text-black mb-2 flex justify-between items-center">
                    <span className="text-xl font-semibold">Nova Categoria</span>
                    <button className="" onClick={() => closeModal()}>
                        <FontAwesomeIcon icon={faCircleXmark} className="text-3xl" />
                    </button>
                </div>
                <div className="rounded-full bg-gray-300 my-2" style={{ height: '2.5px' }} />
                <form onSubmit={formCategoriaSubmit}>
                    <div className="space-y-2">
                        <div className="space-x-2 flex">
                            <Input placeholder="Informe o nome da categoria" size="medium" referencia={inputCategoria} />
                        </div>
                        <div className="flex items-center justify-between mt-4">
                            <label htmlFor="dividir-item" className="font-medium text-gray-700">
                                Permitir divisão meio a meio
                            </label>
                            <button
                                type="button"
                                onClick={() => setPermiteDivisao(!permiteDivisao)}
                                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 ${permiteDivisao ? 'bg-green-500' : 'bg-gray-300'
                                    }`}
                            >
                                <span
                                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${permiteDivisao ? 'translate-x-5' : 'translate-x-1'
                                        }`}
                                />
                            </button>
                        </div>
                    </div>
                    <div className="flex items-center justify-between space-x-2 mt-3">
                        <SecondaryButton onClick={() => closeModal()}>
                            Cancelar
                        </SecondaryButton>
                        <PrimaryButton>
                            Cadastrar
                        </PrimaryButton>
                    </div>
                </form>
            </Modal>

            <Modal isOpen={isModalAdicionais} onClose={closeModal}>
                <div className="text-black mb-2 flex justify-between items-center">
                    <span className="text-xl font-semibold">Adicionais</span>
                    <button className="" onClick={() => closeModal()}>
                        <FontAwesomeIcon icon={faCircleXmark} className="text-3xl" />
                    </button>
                </div>
                <div className="rounded-full bg-gray-300 my-2" style={{ height: '2.5px' }} />

                <div className="md:flex justify-between my-2 space-y-2 md:space-y-0">
                    <div className="flex">
                        <input
                            type="text"
                            ref={searchAdicionais}
                            placeholder="Filtrar por nome"
                            className="text-md border focus:outline-none w-full h-8 md:h-10 p-2 rounded-tl-[10px] rounded-bl-[10px]"
                        />
                        <div className="w-auto">
                            <PrimaryButton
                                className={"rounded-tl-none rounded-bl-none"}
                                onClick={() => buscarAdicionais(searchAdicionais.current?.value)}
                            >
                                <FontAwesomeIcon icon={faMagnifyingGlass} className="text-xl" />
                            </PrimaryButton>
                        </div>
                    </div>
                    <div className="w-auto">
                        <PrimaryButton onClick={() => {
                            if (alterandoAdicional !== 0) {
                                setAlterandoAdicional(0);
                                var dados = {
                                    id: 0,
                                    nome: null,
                                    valorExtra: null,
                                    ativo: true
                                }
                                setAdicionais(prevAdicionais => [dados, ...prevAdicionais]);
                            }
                        }}>
                            Novo Adicional
                            <FontAwesomeIcon icon={faPlus} className="text-xl ml-2" />
                        </PrimaryButton>
                    </div>
                </div>


                <div className="w-full">
                    <table className="w-full border">
                        <thead>
                            <tr className="bg-gray-100">
                                <th className="p-2">Nome</th>
                                <th className="p-2">Preço Extra</th>
                                <th className="p-2">Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {adicionais.map(adicional => (
                                <tr key={adicional.id} className="border-t text-center">
                                    <td className="p-2">
                                        {alterandoAdicional !== -1 && alterandoAdicional === adicional.id ?
                                            <input
                                                type="text"
                                                placeholder="Nome"
                                                className="text-md border focus:outline-none w-auto h-10 p-2 rounded-[10px]"
                                                value={tituloAdicional} onChange={(e) => setTituloAdicional(e.target.value)}
                                            /> :
                                            adicional.nome
                                        }
                                    </td>
                                    <td className="p-2">
                                        {alterandoAdicional !== -1 && alterandoAdicional === adicional.id ?
                                            <div className="flex pl-5">
                                                <div className="h-10 flex items-center bg-gray-200 text-gray-600 p-2 rounded-tl-[10px] rounded-bl-[10px]">
                                                    R$
                                                </div>
                                                <input
                                                    type="number"
                                                    placeholder="Valor"
                                                    className="text-md border focus:outline-none w-20 h-10 rounded-tr-[10px] rounded-br-[10px] pl-2 pr-1"
                                                    value={valorExtraAdicional} onChange={(e) => setValorExtraAdicional(e.target.value)}
                                                />
                                            </div> :
                                            adicional.valorExtra === 0.00 ? "Gratuito" : formatValue(adicional.valorExtra)
                                        }
                                    </td>
                                    <td className="p-2 space-y-1 md:space-y-0 md:space-x-2">
                                        {alterandoAdicional !== -1 && alterandoAdicional === adicional.id ?
                                            <>
                                                {alterandoAdicional === 0 &&
                                                    <button className="w-10 py-2 bg-blue-700 hover:bg-blue-800 active:bg-blue-900 text-white rounded-[10px]" onClick={() => cadastrarAdicional()}>
                                                        <FontAwesomeIcon icon={faPlus} className="text-xl" />
                                                    </button>
                                                }
                                                {alterandoAdicional > 0 &&
                                                    <button className="w-10 py-2 bg-blue-700 hover:bg-blue-800 active:bg-blue-900 text-white rounded-[10px]" onClick={() => atualizarAdicional(adicional.id)}>
                                                        <FontAwesomeIcon icon={faCheck} className="text-xl" />
                                                    </button>
                                                }
                                                <button className="w-10 py-2 bg-red-500 hover:bg-red-600 active:bg-red-700 text-white rounded-[10px]" onClick={() => {
                                                    setAlterandoAdicional(-1);
                                                    setTituloAdicional(null);
                                                    setValorExtraAdicional(null);
                                                    setAdicionais(prevAdicionais => prevAdicionais.filter(adicional => adicional.id !== 0));
                                                }}>
                                                    <FontAwesomeIcon icon={faXmark} className="text-xl" />
                                                </button>
                                            </>
                                            :
                                            <>
                                                <button className="w-10 py-2 bg-yellow-600 hover:bg-yellow-700 text-white rounded-[10px]" onClick={() => { setAlterandoAdicional(adicional.id); setTituloAdicional(adicional.nome); setValorExtraAdicional(adicional.valorExtra); }}>
                                                    <FontAwesomeIcon icon={faPen} />
                                                </button>
                                                <button className="w-10 py-2 bg-red-500 hover:bg-red-600 active:bg-red-700 text-white rounded-[10px]" onClick={() => deleteAdicional(adicional.id)}>
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                            </>
                                        }
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </Modal>

            <Modal isOpen={isPromoOpen} size="w-full max-w-md" zIndex={30}>
                <h2 className="text-xl font-bold text-gray-800 mb-4">Promoção - {produtoSelecionado?.titulo}</h2>

                <div className="space-y-4">
                    <div className="flex items-center justify-between">
                        <label className="block text-sm font-medium text-gray-700">Ativar Promoção</label>
                        <button
                            type="button"
                            onClick={() => setPromoAtiva(prev => !prev)}
                            className={`relative inline-flex h-6 w-12 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 ${promoAtiva ? 'bg-green-500' : 'bg-gray-300'
                                }`}
                        >
                            <span
                                className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${promoAtiva ? 'translate-x-7' : 'translate-x-1'
                                    }`}
                            />
                        </button>
                    </div>

                    {promoAtiva && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Preço Promocional</label>
                            <input
                                type="number"
                                className="w-full border rounded-md px-3 py-2 text-sm focus:ring focus:ring-green-200 focus:outline-none"
                                value={valorPromocional}
                                onChange={(e) => setValorPromocional(Number(e.target.value))}
                                placeholder="Ex: 19.90"
                                min={0.01}
                                step={0.01}
                            />
                        </div>
                    )}
                </div>

                <div className="mt-6 flex justify-end gap-2">
                    <button
                        onClick={closeModalPromocao}
                        className="px-4 py-2 text-sm rounded-md border text-gray-700 hover:bg-gray-100"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleSubmitPromocao}
                        className="px-4 py-2 text-sm rounded-md bg-green-600 text-white hover:bg-green-700"
                    >
                        Salvar
                    </button>
                </div>
            </Modal>

            <div className="p-2 py-4 sm:p-5 text-black">
                <div className="flex flex-wrap justify-between">
                    <div className="items-center hidden sm:flex">
                        <span className="text-xl font-semibold">Categorias</span>
                    </div>
                    <div className="flex space-x-1 sm:space-x-2 mb-2 w-full sm:w-auto">
                        <div className="relative inline-block text-left w-full">
                            <PrimaryButton
                                onClick={toggleDropdown}
                            >
                                <FontAwesomeIcon icon={faMagnifyingGlass} className="text-md sm:text-xl" />
                            </PrimaryButton>

                            {isOpen && (
                                <div
                                    ref={dropdownRef}
                                    className="absolute mt-2 w-80 rounded-[10px] shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-10"
                                    style={{ top: '100%', left: '0' }}
                                >
                                    <div className="p-3" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                                        <div className="mb-2 text-center">
                                            <span className="text-lg font-semibold">Filtros:</span>
                                        </div>
                                        <form onSubmit={handleSubmit}>
                                            <div
                                                className="text-black px-2 items-center rounded-[10px] flex h-10 my-3 border border-gray-300"
                                                style={{ cursor: 'pointer', backgroundColor: 'rgba(0, 0, 0, 0.05)', boxShadow: '0 4px 4px rgba(0, 0, 0, 0.25)' }}
                                            >
                                                <div className="items-center w-full h-10 flex">
                                                    <input
                                                        ref={inputSearch}
                                                        type="text"
                                                        placeholder="Categoria"
                                                        className="text-md placeholder-black bg-transparent border-none focus:outline-none w-full h-10"
                                                    />
                                                </div>
                                            </div>
                                            <PrimaryButton>
                                                Buscar
                                            </PrimaryButton>
                                        </form>
                                    </div>
                                </div>
                            )}
                        </div>
                        <PrimaryButton className="text-sm sm:text-md w-full" onClick={() => openAddCategoria()}>
                            Nova Categoria
                            <FontAwesomeIcon icon={faPlus} className="text-md sm:text-xl ml-2" />
                        </PrimaryButton>
                        <PrimaryButton className="text-sm sm:text-md w-full" onClick={() => { openAdicionais(); buscarAdicionais(); }}>
                            Adicionais
                            <FontAwesomeIcon icon={faGear} className="text-md sm:text-xl ml-2" />
                        </PrimaryButton>
                    </div>
                </div>

                {categorias.filter(categoria => categoria.ativo).map(categoria => (
                    <div key={categoria.id} className="bg-white border border-gray-300 rounded-[10px] py-2 sm:py-4 px-2 sm:px-6 my-2">
                        <div className={`${secoesAbertas[categoria.id] ? "" : "flex"} sm:flex space-y-2 sm:space-y-0 justify-between sm:space-x-2`}>
                            <div className="space-x-3 flex items-center cursor-pointer select-none w-full" onDoubleClick={() => setCategoriaEdit(categoria)}>
                                {categoriaEdit.id !== categoria.id ?
                                    <div className={`space-x-2 w-full ${secoesAbertas[categoria.id] ? "text-center" : ""} sm:text-start`}>
                                        <span className="font-medium text-lg sm:text-xl">{categoria.nome}</span>
                                        <FontAwesomeIcon icon={faPenToSquare} className="text-lg sm:text-xl" onClick={() => setCategoriaEdit(categoria)} />
                                    </div>
                                    :
                                    <div className="flex flex-col md:flex-row items-center space-y-1 w-full xl:w-5/6 md:space-y-0 md:space-x-2">
                                        <div className="w-full md:w-1/4">
                                            <PrimaryButton className="bg-red-500 hover:bg-red-600 active:bg-red-700 py-2 space-x-2" onClick={() => setCategoriaDelete(categoria)}>
                                                <FontAwesomeIcon icon={faTrashCan} className="text-xl" />
                                                <span className="md:hidden">Deletar</span>
                                            </PrimaryButton>
                                        </div>
                                        <Input
                                            placeholder="Nome da Categoria"
                                            size="medium"
                                            value={categoriaEdit.nome}
                                            referencia={inputEditCategoria}
                                            onChange={(e) => {
                                                setCategoriaEdit(prevState => ({
                                                    ...prevState,
                                                    nome: e
                                                }));
                                            }}
                                        />
                                        <div className="flex items-center justify-between md:justify-center w-full md:space-x-2">
                                            <label
                                                htmlFor="switch-edit"
                                                className="text-sm font-medium text-gray-700"
                                            >
                                                Permite meio a meio
                                            </label>

                                            <button
                                                id="switch-edit"
                                                type="button"
                                                onClick={() =>
                                                    setCategoriaEdit(prev => ({
                                                        ...prev,
                                                        permiteDivisao: !prev.permiteDivisao
                                                    }))
                                                }
                                                className={`relative inline-flex h-6 w-12 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 ${categoriaEdit.permiteDivisao ? 'bg-green-500' : 'bg-gray-300'
                                                    }`}
                                            >
                                                <span
                                                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${categoriaEdit.permiteDivisao ? 'translate-x-7' : 'translate-x-1'
                                                        }`}
                                                />
                                            </button>
                                        </div>
                                        <div className="w-full md:w-1/4">
                                            <PrimaryButton className="py-2 space-x-2" onClick={() => editCategoriaSubmit(categoria.id, categoria.nome)}>
                                                <FontAwesomeIcon icon={faFloppyDisk} className="text-xl" />
                                                <span className="md:hidden">Salvar</span>
                                            </PrimaryButton>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="text-end space-x-2 justify-between sm:w-full flex sm:block">
                                <button className={`py-1 px-3 bg-blue-700 text-white rounded-[10px] justify-between space-x-2 hover:bg-blue-800 transition-all duration-500 ease-out ${!secoesAbertas[categoria.id] && 'hidden'}`} onClick={() => { handleNewProduct(categoria.id); }}>
                                    <FontAwesomeIcon icon={faPlus} />
                                    <span>
                                        Adicionar Produto
                                    </span>
                                </button>
                                <button className="w-8 py-1 border border-gray-400 rounded-[10px]" onClick={() => toggleSecao(categoria.id)}>
                                    <FontAwesomeIcon icon={!secoesAbertas[categoria.id] ? faChevronRight : faChevronDown} />
                                </button>
                            </div>
                        </div>
                        <div className={`transition-all duration-500 ease-out ${secoesAbertas[categoria.id] ? 'h-auto opacity-100 mt-4' : 'h-0 opacity-0 mt-0'}`}>
                            {secoesAbertas[categoria.id] &&
                                <>
                                    {produtos[categoria.id] === undefined ? (
                                        <div>Carregando...</div>
                                    ) : produtos[categoria.id].length === 0 ? (
                                        <div>Nenhum produto cadastrado</div>
                                    ) : (
                                        produtos[categoria.id].filter(produto => produto.ativo).map(produto => (
                                            <div key={produto.id} className="flex space-x-1 border justify-between rounded-[10px] py-2 px-1 sm:px-4 mb-2">
                                                <div className="flex items-center space-x-2 sm:space-x-4">
                                                    <img src={produto.url_Imagem} alt="Lanche" className="w-16 sm:w-24 sm:h-20 rounded-[10px] object-cover" />
                                                    <div className="grid">
                                                        <span className="sm:text-lg font-medium flex items-center gap-2">
                                                            {produto.titulo}
                                                            {produto.emPromocao && (
                                                                <span className="bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">
                                                                    Promoção
                                                                </span>
                                                            )}
                                                        </span>
                                                        {produto.emPromocao ? (
                                                            <div className="flex items-center space-x-2">
                                                                <span className="text-sm line-through text-gray-500">{formatValue(produto.valor)}</span>
                                                                <span className="text-md font-bold text-green-600">{formatValue(produto.valorPromocional)}</span>
                                                            </div>
                                                        ) : (
                                                            <span className="text-md font-normal">{formatValue(produto.valor)}</span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="space-x-1 sm:space-x-2 flex items-center">
                                                    {/* Botão Promoção */}
                                                    <div className="relative group">
                                                        <button
                                                            className="w-8 sm:w-10 py-1 sm:py-2 bg-green-600 hover:bg-green-700 text-white rounded-[10px]"
                                                            onClick={() => openModalPromocao(produto, categoria.id)}
                                                        >
                                                            <FontAwesomeIcon icon={faTag} />
                                                        </button>
                                                        <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap shadow-md">
                                                            Colocar em promoção
                                                        </span>
                                                    </div>

                                                    {/* Botão Editar */}
                                                    <div className="relative group">
                                                        <button
                                                            className="w-8 sm:w-10 py-1 sm:py-2 bg-yellow-600 hover:bg-yellow-700 text-white rounded-[10px]"
                                                            onClick={() => openModalEditProduto(produto, categoria.id)}
                                                        >
                                                            <FontAwesomeIcon icon={faPen} />
                                                        </button>
                                                        <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap shadow-md">
                                                            Editar produto
                                                        </span>
                                                    </div>

                                                    {/* Botão Excluir */}
                                                    <div className="relative group">
                                                        <button
                                                            onClick={() => setProdutoDelete([produto, categoria])}
                                                            className="w-8 sm:w-10 py-1 sm:py-2 bg-red-500 hover:bg-red-600 active:bg-red-700 text-white rounded-[10px]"
                                                        >
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </button>
                                                        <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap shadow-md">
                                                            Excluir produto
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </>
                            }
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}

export default GestaoCardapio;